export default function Courses() {
  const courses = [
    {
      title: "Cybersecurity Introduction",
      file: "/courses/cybersecurity_intro.pdf",
    },
    {
      title: "Networking Basics",
      file: "/courses/networking_basics.pdf",
    },
    {
      title: "Linux Fundamentals",
      file: "/courses/linux_fundamentals.pdf",
    },
    {
      title: "Digital Forensics",
      file: "/courses/digital_forensics.pdf",
    },
  ];

  return (
    // ❌ ml-64 REMOVED FROM HERE
    <div className="bg-gray-950 min-h-screen text-white flex">

      {/* ================= LEFT COURSE INDEX ================= */}
      <aside className="w-80 bg-gray-900/70 border-r border-gray-800 p-6">
        <h2 className="text-lg font-bold mb-5 text-blue-400">
          Course Index
        </h2>

        <ul className="space-y-3">
          {courses.map((course, index) => (
            <li key={course.title}>
              <a
                href={course.file}
                target="_blank"
                rel="noopener noreferrer"
                className="block px-4 py-3 rounded-lg
                bg-gray-800 hover:bg-gray-700 transition"
              >
                <span className="text-sm text-gray-400 mr-2">
                  {index + 1}.
                </span>
                <span className="font-medium">
                  {course.title}
                </span>
              </a>
            </li>
          ))}
        </ul>

        <p className="text-xs text-gray-500 mt-6">
          Click any topic to open the PDF
        </p>
      </aside>

      {/* ================= MAIN CONTENT ================= */}
      <div className="flex-1 p-8">
        <h1 className="text-3xl font-bold mb-6">
          Cybersecurity Courses
        </h1>

        <div className="grid md:grid-cols-2 gap-6">
          {courses.map((course) => (
            <div
              key={course.title}
              className="bg-gray-900 border border-gray-800 p-6 rounded-xl
              hover:border-blue-500 transition"
            >
              <h2 className="text-xl font-semibold mb-3">
                {course.title}
              </h2>

              <a
                href={course.file}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-blue-600 hover:bg-blue-700
                px-5 py-2 rounded-lg font-semibold"
              >
                📄 Open PDF
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
